export const cvData = {
  personal: {
    name: "Richard Widemann",
    title: "Développeur Full Stack",
    subtitle: "Node.js / React / ASP.NET / SQL",
    location: "Disponible dans toute la France",
    email: "richard.widemann@epitech.eu",
    phone: "06 52 47 03 80",
    profile: "Développeur fullstack (Node.js, React, ASP.NET, SQL Server). Ce que j'aime dans le métier de développeur, c'est le fait de créer quelque chose d'utile pour d'autres personnes."
  },
  
  disponibilite: {
    ligne1: "Disponible pour échanger sur vos missions",
    ligne2: "De préférence en full remote mais ouvert à d'autres propositions.",
    site: "C'est mon site actuel :",
    lien: "richardwidemannweb.fr",
    cta: "Parlons de votre projet !"
  },

  // GRILLE DE TECHNOLOGIES DYNAMIQUE (inspirée de zalt.me)
  techStack: [
    { name: "React", category: "frontend", level: 55, icon: "⚛️" },
    { name: "Node.js", category: "backend", level: 80, icon: "🟢" },
    { name: "Python", category: "languages", level: 70, icon: "🐍" },
    // { name: "TypeScript", category: "frontend", level: 82, icon: "📘" },
    { name: "JavaScript", category: "frontend", level: 70, icon: "📜" },
    { name: "SQL", category: "database", level: 80, icon: "🗄️" },
    { name: "SQL Server", category: "database", level: 83, icon: "🔶" },
    { name: "MongoDB", category: "database", level: 40, icon: "🍃" },
    { name: "Docker", category: "devops", level: 35, icon: "🐳" },
    { name: "Git", category: "tools", level: 50, icon: "📦" },
    { name: "WordPress", category: "cms", level: 40, icon: "🔵" },
    { name: "C/C++", category: "languages", level: 45, icon: "⚙️" },
    { name: "ASP.NET", category: "backend", level: 55, icon: "🔷" },
    { name: "WinDev", category: "tools", level: 65, icon: "🪟" },
    { name: "API REST", category: "concept", level: 92, icon: "🔌" },
    // { name: "Web Scraping", category: "data", level: 84, icon: "🕸️" },
  ],

  experiences: [
    {
      title: "Développeur Web Freelance",
      period: "2025 - Aujourd'hui",
      description: "J'accompagne des clients sur leurs projets web, de A à Z :",
      achievements: [
        "Accompagnement du client dans le choix des besoins/différentes pages et textes à afficher/différentes fonctionnalités à développer",
        "Créations de plusieurs templates du site web pour que l'utilisateur puisse choisir celui qui lui correspond le mieux",
        "Réalisations : ",
        "LOCATION SAISONNIERE",
        "-Création d'un site web pour des locations saisonnières avec système de paiement et réservation en ligne.",
        "-Gestion des envois de mails en cas de réservation/annulation/paiement refusé.-Interface administrateur pour pouvoir bloquer des dates/ajouter manuellement des réservations/changer le prix d'une nuit",
        "-Traduction du site et des mails en anglais",
        "LOCATION JEEP",
        "-Création d'un site pour des locations de jeep",
        "-Intégration des textes et médias sur une page web",
        "-Choix des polices et des palettes de couleurs",
        "-Gestion du responsive (version mobile et tablette)"
      ],
      freelance: true
    },
    {
      title: "Développeur Web & Logiciel – Stage puis Alternance",
      company: "Computer Associés – Marseille",
      period: "2023 – 2025",
      description: "Pendant 2 ans, j'ai développé des outils pour des professionnels du retail.",
      achievements: [
        "Création de scripts WinDev et d'un serveur ASP.NET pour transférer automatiquement les données des magasins vers un serveur cloud",
        "Création d'une nouvelle base de données cloud avec des tables plus lisibles, contenant uniquement les données essentielles",
        "Développement d'un site web permettant aux gérants de consulter leurs KPI : chiffre d'affaires, panier moyen, démarque et marge (React, Node.js, SQL Server)",
        "Consultation et comparaison simultanées des statistiques de plusieurs magasins",
        "Mise en place de l'authentification par token JWT et de la gestion des mots de passe oubliés",
        "Optimisation des procédures stockées SQL Server afin d'améliorer les temps de réponse",
        "Centralisation des données de 300 magasins, représentant 100 Go de données",
        "Solution utilisée par 30 clients",

        "Développement d'un outil interne intégré au back office d'envoi de campagnes de mailing et de SMS, cela à permis au clients de réduire leurs couts et de ne pas avoir besoin de passer par un autre service pour faire cela.",
        "Création des bons d'achat lors de la campagne de mailing si nécessaire."
      ],
      image: "/images/computer-associes.jpg" // Placeholder pour image
    },
    {
      title: "Développeur – Stage",
      company: "Moulin coopératif de Mouriès",
      period: "2021",
      achievements: [
        "Création d'un intranet pour l'équipe permettant la communication interne + la communication aux clients",
        "Gestion des connexions/droits administrateurs",
        "Amélioration du site existant (référencement/visibilité)"
      ],
      image: "/images/moulin-mouries.jpg"
    }
  ],

  competences: {
    langages: [
      { name: "JavaScript / Node.js", level: 65 },
      { name: "React", level: 55 },
      { name: "Python", level: 70 },
      { name: "SQL", level: 80 },
      { name: "C / C++", level: 45 },
      { name: "WordPress", level: 40 }
    ],
    concepts: [
      "Création d'API",
      "Architecture backend",
      "Traitement de données",
      // "Web scraping",
      "Algorithmes"
    ]
  },

  formation: {
    school: "Epitech – Marseille",
    period: "2020 – 2025",
    title: "Architecte logiciel, développeur d'applications (Bac+5)"
  },

  projets: [
    {
      title: "Cryptoviz – Analyse de crypto en temps réel",
      description: "Une application qui collecte et analyse les données du marché crypto.",
      technologies: ["Node.js", "Angular", "SQL Server", "Python", "Binance API", "CoinGecko API"],
      role: "Backend et conception de la base de données",
      icon: "📈",
      image: "/images/bitcoin-logo.webp",
      gradient: "from-violet-600 to-blue-600"
    },
    {
      title: "HomePedia – Exploration du marché immobilier",
      description: "Une carte interactive pour visualiser les données immobilières en France.",
      technologies: ["Node.js", "Angular", "MongoDB", "Python"],
      role: "Backend, base de données, algorithmes de tri",
      icon: "🏠",
      image: "/images/cle.webp",
      gradient: "from-blue-600 to-cyan-600"
    },
    {
      title: "Travel Order Resolver – Voyages intelligents",
      description: "Un outil qui comprend une requête en français et génère un itinéraire optimisé.",
      technologies: ["Python", "BERT", "Dijkstra", "A*"],
      role: "Pathfinding et préparation des données",
      icon: "🌍",
      image: "/images/maze.webp",
      gradient: "from-green-600 to-emerald-600"
    },
    {
      title: "SoundtoolsGPT – Quand l'IA fait de la musique",
      description: "Un chatbot qui aide à générer des éléments musicaux.",
      technologies: ["Java Spring Boot", "Angular", "PostgreSQL", "Python"],
      role: "Algorithmes de génération musicale et IA",
      icon: "🎵",
      image: "/images/mixing.webp",
      gradient: "from-pink-600 to-purple-600"
    }
  ],

  softSkills: [
    "Je collabore facilement",
    "Je m'adapte sans problème",
    "Je trouve des solutions créatives",
    "J'apprends super vite"
  ],

  interests: [
    { name: "Production musicale", icon: "🎵", description: "Pour décompresser" },
    { name: "Jeu d'échecs", icon: "♟️", description: "Pour réfléchir autrement" }
  ],

  objective: "Créer des applications qui servent vraiment à quelque chose. Et en profiter pour progresser, relever des défis, et travailler avec des gens sympas.",

  footer: {
    copyright: "© 2026 Richard Widemann • Développeur Full Stack",
    email: "richard.widemann@epitech.eu",
    phone: "06 52 47 03 80"
  }
}